// Colours of the personal calendar. Two channels never mix: the fill tells
// the status, the left stripe tells the project (see utils/projectColors).

export const VISIT_STATE_TONES = {
  completedDay: {
    chip: 'tw-bg-emerald-500/20 tw-text-emerald-900 dark:tw-bg-emerald-400/20 dark:tw-text-emerald-100',
    dot: 'tw-bg-emerald-500',
    pill: 'success',
  },
  completed: {
    chip: 'tw-bg-emerald-500/10 tw-text-emerald-800 dark:tw-bg-emerald-400/10 dark:tw-text-emerald-200',
    dot: 'tw-bg-emerald-400',
    pill: 'success',
  },
  windowClosed: {
    chip: 'tw-bg-slate-500/[0.08] tw-text-slate-500 dark:tw-bg-white/[0.04] dark:tw-text-slate-400',
    dot: 'tw-bg-slate-300 dark:tw-bg-slate-600',
    pill: 'neutral',
  },
  inProgress: {
    chip: 'tw-bg-amber-400/25 tw-text-amber-950 dark:tw-bg-amber-400/15 dark:tw-text-amber-100',
    dot: 'tw-bg-amber-500',
    pill: 'warning',
  },
  overdue: {
    chip: 'tw-bg-rose-500/15 tw-text-rose-900 dark:tw-bg-rose-500/20 dark:tw-text-rose-100',
    dot: 'tw-bg-rose-500',
    pill: 'danger',
  },
  planned: {
    chip: 'tw-bg-indigo-500/10 tw-text-indigo-900 dark:tw-bg-indigo-400/15 dark:tw-text-indigo-100',
    dot: 'tw-bg-indigo-500',
    pill: 'info',
  },
};

/**
 * Window bars of the month grid, by the visit's overall state: `bar` is the
 * whole window (light), `mark` the visit day inside it (strong).
 */
export const BAR_TONES = {
  planned: {
    bar: 'tw-bg-indigo-500/[0.09] tw-text-indigo-900 dark:tw-bg-indigo-400/[0.12] dark:tw-text-indigo-100',
    mark: 'tw-bg-indigo-500/25 dark:tw-bg-indigo-400/30',
  },
  inProgress: {
    bar: 'tw-bg-amber-400/[0.16] tw-text-amber-950 dark:tw-bg-amber-400/[0.12] dark:tw-text-amber-100',
    mark: 'tw-bg-amber-400/50 dark:tw-bg-amber-400/35',
  },
  overdue: {
    bar: 'tw-bg-rose-500/[0.1] tw-text-rose-900 dark:tw-bg-rose-500/[0.14] dark:tw-text-rose-100',
    mark: 'tw-bg-rose-500/30 dark:tw-bg-rose-500/40',
  },
  completed: {
    bar: 'tw-bg-emerald-500/[0.1] tw-text-emerald-900 dark:tw-bg-emerald-400/[0.12] dark:tw-text-emerald-100',
    mark: 'tw-bg-emerald-500/30 dark:tw-bg-emerald-400/35',
  },
  screenFail: {
    bar: 'tw-bg-fuchsia-500/[0.1] tw-text-fuchsia-900 dark:tw-bg-fuchsia-400/[0.14] dark:tw-text-fuchsia-100',
    mark: 'tw-bg-fuchsia-500/30 dark:tw-bg-fuchsia-400/35',
  },
};

export const SCREEN_FAIL_TONE = {
  chip: 'tw-bg-fuchsia-500/10 tw-text-fuchsia-900 dark:tw-bg-fuchsia-400/15 dark:tw-text-fuchsia-100',
  dot: 'tw-bg-fuchsia-500',
};

export const JOB_STATE_TONES = {
  done: { text: 'tw-text-emerald-700 dark:tw-text-emerald-300', dot: 'tw-bg-emerald-500', pill: 'success' },
  today: { text: 'tw-text-amber-700 dark:tw-text-amber-300', dot: 'tw-bg-amber-500', pill: 'warning' },
  planned: { text: 'tw-text-indigo-700 dark:tw-text-indigo-300', dot: 'tw-bg-indigo-500', pill: 'info' },
  overdue: { text: 'tw-text-rose-700 dark:tw-text-rose-300', dot: 'tw-bg-rose-500', pill: 'danger' },
};

// Project stripe by colour slot (0 = no slot left: neutral)
export const PROJECT_STRIPES = {
  1: 'tw-border-l-[#2a78d6] dark:tw-border-l-[#3987e5]',
  2: 'tw-border-l-[#eb6834] dark:tw-border-l-[#d95926]',
  3: 'tw-border-l-[#1baf7a] dark:tw-border-l-[#199e70]',
  0: 'tw-border-l-[#94a3b8] dark:tw-border-l-[#7e8a9c]',
};

export const PROJECT_SWATCHES = {
  1: 'tw-bg-[#2a78d6] dark:tw-bg-[#3987e5]',
  2: 'tw-bg-[#eb6834] dark:tw-bg-[#d95926]',
  3: 'tw-bg-[#1baf7a] dark:tw-bg-[#199e70]',
  0: 'tw-bg-[#94a3b8] dark:tw-bg-[#7e8a9c]',
};

export const LEAVE_TONE = 'tw-bg-sky-500/10 tw-text-sky-800 dark:tw-bg-sky-400/10 dark:tw-text-sky-200';
